import axiosInstance from 'plugins/axios';
import { IBodyResponse } from 'types/type.global';

export const overviewCardInfo = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(`admin/overviews/card_info`, {
        params,
    });
    return response.data;
};

export const overViewChartCollectData = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(
        `admin/overviews/chart_collect_data`,
        {
            params,
        }
    );
    return response.data;
};

export const overViewChartCampaignCollectData = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(
        `admin/overviews/chart_campaign_collect_data`,
        {
            params,
        }
    );
    return response.data;
};

export const overviewChartDevice = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(`admin/overviews/chart_device`, {
        params,
    });
    return response.data;
};

export const overviewChartArea = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(`admin/overviews/chart_area`, {
        params,
    });
    return response.data;
};

export const overviewChartAccount = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(`admin/overviews/chart_account`, {
        params,
    });
    return response.data;
};
